import { ActivityType, Box, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

export const Wrapper = styled(Box)`
  background-color: ${({ theme }) => theme.colors.module};
`;

interface BarProps {
  width: number;
  typeKey?: ActivityType;
}
export const Bar = styled(Text)<BarProps>`
  ${({ theme }) => theme.fonts.text16Bold};
  height: 48px;
  width: ${({ width = 5 }) => width}%;
  min-width: 25px;
  transition: all 0.15s;
  background-color: ${({ theme, typeKey }) =>
    typeKey
      ? theme.colors.activity[typeKey] || theme.colors.activity[ActivityType.OTHER]
      : theme.colors.border2};
  color: ${({ theme, typeKey }) => (typeKey ? theme.colors.iconOnColor : theme.colors.textDisabled)};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChartWrapper = styled(Box)`
  position: relative;
`;

interface ContentWrapperProps {
  inlineMode?: boolean;
  isWithoutHeader?: boolean;
  isPortfolioMode?: boolean;
}
export const ContentWrapper = styled(Box)<ContentWrapperProps>`
  display: flex;
  ${({ theme, isPortfolioMode }) => {
    if (isPortfolioMode) {
      return {
        borderRadius: `${theme.rounds.container1Round} ${theme.rounds.container1Round} 0 0`,
      };
    }

    return {
      borderRadius: theme.rounds.container1Round,
    };
  }};
  flex-direction: column;
  ${({ inlineMode, theme }) => {
    if (inlineMode) {
      return {
        padding: `${theme.spacings.spacing24}`,
        backgroundColor: theme.colors.canvas,
      };
    }
    return {};
  }}
`;

export const Title = styled.h3`
  ${({ theme }) => theme.fonts.text16Bold};
  flex: 1;
  color: ${({ theme }) => theme.colors.blockTitle || ''};
`;
export const LabelsWrapper = styled(Box)`
  flex: 1;
  flex-wrap: wrap;
  position: relative;
`;

interface LabelProps {
  typeKey: ActivityType;
  inline?: boolean;
  marginless?: boolean;
}
export const Label = styled(Text)<LabelProps>`
  width: ${({ inline }) => (inline ? undefined : '33.33%')};
  ${({ theme }) => theme.fonts.text12Medium};
  padding-left: 20px;
  padding-right: ${({ inline, theme }) => (inline ? theme.spacings.spacing32 : undefined)};
  margin-right: ${({ theme, inline }) => (inline ? theme.spacings.spacing8 : undefined)};
  margin-top: ${({ theme, inline }) => (inline ? theme.spacings.spacing12 : undefined)};
  box-sizing: border-box;
  position: relative;
  margin-bottom: ${({ theme }) => theme.spacings.spacing4};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin: ${({ marginless }) => marginless && '0'};
  &::before {
    content: '';
    left: 0;
    top: 3px;
    position: absolute;
    width: 12px;
    height: 12px;
    border-radius: ${({ theme }) => theme.rounds.smallRound};
    background-color: ${({ theme, typeKey }) =>
      theme.colors.activity[typeKey] || theme.colors.activity[ActivityType.OTHER]};
  }
`;

export const TotalHeader = styled.h4`
  ${({ theme }) => theme.fonts.text16Bold};
`;

export const DropdownWrapper = styled(Box)`
  width: ${({ theme }) => theme.controls.width};
`;

export const TipWrapper = styled(Box)`
  ${({ theme }) => theme.shadows.active};
  margin: 20px auto;
  position: relative;
`;
